import { Link } from "react-router-dom";
import { HotelType } from "../../../backend/src/shared/types";
import { AiFillStar } from "react-icons/ai";
// import PackageIcon from '../assets/Package.svg'; // Correctly point to your SVG files
// import HotelsIcon from '../assets/hotels.svg';
// import FlightsandHotelIcon from '../assets/Flights-and-Hotels.svg';
import { useEffect, useState } from "react";
// import { PerNightPrice } from "./HotelPriceComponent";
import { useSearchContext } from "../contexts/SearchContext";
import * as apiClient from '../api-client';
import { PropertyAvailabilityResponse } from "../../../backend/src/models/getPropertyAvailability";
import { PropertyDetails } from "../../../backend/src/models/getPropertyDetails";
import { getUsdToGbpExchangeRate } from '../api-client';


type Props = {
  hotel: HotelType;
};

const SearchResultsCard = ({ hotel }: Props) => {
  const { checkIn, checkOut, adultCount, childCount, childAges, vacationType } = useSearchContext();
  const [availablePropertyData, setAvailablePropertyData] = useState<PropertyAvailabilityResponse | null>(null);
  const [propertyDetails, setHotelDetails] = useState<PropertyDetails | null>(null);
  const [rate, setRate] = useState<number | null>(null);


  // const renderSVGIcon = () => {
  //   switch (hotel.packageType) {
  //     case './src/assets/Package.svg':
  //       return <img loading="lazy" src={PackageIcon} alt="Hotels Only" />;
  //     case './src/assets/hotels.svg':
  //       return <img loading="lazy" src={HotelsIcon} alt="Hotels Only" />;
  //     case './src/assets/Flights-and-Hotels.svg':
  //       return <img loading="lazy" src={FlightsandHotelIcon} alt="Flights and Hotels Only" />;
  //     default:
  //       return null; // Or your default icon
  //   }
  // };

  useEffect(() => {

    const getResponseTokenForSearch = async () => {
      try {
        const tokenRequest = {
          source: {
            userEmail: 'ajanth@haloflights.co.uk',
            requestRef: '1000987654321234567890'
          },
          requestCriteria: {
            region: 'CBD',
            destination: {
              destinationCode: hotel!.destinationCode,
              locationCode: 'ANY',
            },
            hotelCodes: [hotel!.destId],
            stayPeriod: {
              checkInDate: checkIn.toISOString().split('T')[0],
              checkOutDate: checkOut.toISOString().split('T')[0],
            },
            nationalityCode: 'GB',
            roomRequests: [
              {
                adults: adultCount,
                children: childCount,
                childAges: childAges.map((age: any) => parseInt(age)),
              },
            ],
            mealTypeCode: '',
            vacationTypeCode: vacationType,
            preferences: {
              availability: 'all',
            },
          }
        };

        const data = await apiClient.getResponseToken(tokenRequest);
        const propertyRoomDetails = await apiClient.fetchPropertyRoomDetails(data.responseToken);
        setAvailablePropertyData(propertyRoomDetails);
      } catch (error) {
        console.error('Error fetching hotel availability:', error);
      }
    };



    if (hotel) {
      getResponseTokenForSearch();
      getPropertyDetails();
    }
  }, [hotel]);

  const getPropertyDetails = async () => {
    try {
      const data = await apiClient.fetchPropertyDetails(hotel.destinationCode, hotel.destId);
      setHotelDetails(data as PropertyDetails);
    } catch (error: any) {
      console.error('Error fetching hotel details:', error);
    }
  }

  // Function to parse and validate price values, allowing undefined as an input
  const parsePrice = (price: string | number | undefined): number => {
    if (price === undefined) {
      return 0; // Return 0 immediately if the input is undefined
    }

    const floatPrice = parseFloat(price.toString());
    return isNaN(floatPrice) ? 0 : floatPrice;
  };
  
  const fetchRate = async () => {
    try {
      const exchangeRate = await getUsdToGbpExchangeRate();
      setRate(exchangeRate);
    } catch (err: any) {
      console.error('Failed to fetch exchange rate:', err);
    }
  };

  useEffect(() => {
    fetchRate();
  }, []);

  const effectiveRate = rate ?? 0.82;

  // Extracting prices using optional chaining, which may result in undefined
  const grossPrice = availablePropertyData?.result[0]?.groups[0]?.rooms[0]?.deals[0]?.price.gross;
  const discountPrice = availablePropertyData?.result[0]?.groups[0]?.rooms[0]?.deals[0]?.price.discount;

  const safeGrossPrice = parsePrice(grossPrice);
  const safeDiscountPrice = parsePrice(discountPrice);

  // Determine if a discount exists and apply a percentage increase to the gross price accordingly
  const increaseRate = safeDiscountPrice > 0 ? 1.04 : 1.05;
  const modifiedGrossPrice = safeGrossPrice * increaseRate;

  // Calculate the discount; if no discount is given, use 1% of the modified gross price
  const finalDiscountPrice = safeDiscountPrice > 0 ? safeDiscountPrice * 1.04 : safeGrossPrice * 0.01;

  // Calculate the final room price by subtracting the discount from the modified gross price
  const roomPriceNew = (modifiedGrossPrice - finalDiscountPrice) * effectiveRate;

  // Total count of adults and children
  const totalCount = adultCount + childCount;

  const depositPrice = roomPriceNew > 0 ? (roomPriceNew / totalCount) * 0.2 : '***';

  const transferArrivalDescription = availablePropertyData?.result[0]?.groups[0]?.rooms[0]?.deals[0]?.info?.transfer?.arrival?.description;


  return (
    <section className="snap-start">

      <div className="flex flex-col md:flex-row h-auto md:h-72 w-full border border-gray-200 rounded-lg shadow-md my-4">
        <div className="min-w-[33%] md:w-1/3 relative">
          <img
            src={hotel.imageUrls[0]}
            alt={`Image of ${hotel.name}`}
            className="object-cover w-full h-60 md:h-full rounded-lg"
          />
          {safeDiscountPrice > 0 && (
            <div className="absolute bg-[#BD1550] ribbon-custom text-white font-normal">
              BIG Savings
            </div>
          )}
        </div>

        {/* Text container */}
        <div className="flex-grow flex flex-col">
          {/* Top part with title and rating */}
          <div className="flex justify-between flex-col p-4">
            <div className="flex gap-2 flex-wrap mb-2 items-center md:hidden lg:hidden lgx2:hidden">
              {hotel.type.slice(0, 3).map((type, index) => (
                <span
                  key={index}
                  className="bg-[#e3eefa] text-xs font-semibold px-2 py-1 rounded text-gray-700"
                >
                  {type}
                </span>
              ))}
              {hotel.type.length > 3 && (
                <Link to={`/resort/${hotel.slug}`} className="text-xs text-gray-500">
                  +{hotel.type.length - 3} more
                </Link>
              )}
            </div>
            <div className="hidden md:block lg:block lgx2:block">
              <div className="flex gap-2 flex-wrap mb-2 items-center">
                {hotel.type.slice(0, 4).map((type, index) => (
                  <span
                    key={index}
                    className="bg-[#e3eefa] text-xs font-semibold px-2 py-1 rounded text-gray-700"
                  >
                    {type}
                  </span>
                ))}
                {hotel.type.length > 4 && (
                  <Link to={`/resort/${hotel.slug}`} className="text-xs text-gray-500">
                    +{hotel.type.length - 4} more
                  </Link>
                )}
              </div>
            </div>
            <div>
              <div className="flex items-center mb-1">
                <span className="flex">
                  {Array.from({ length: hotel.starRating }).map((_, index) => (
                    <AiFillStar key={index} className="text-yellow-400" />
                  ))}
                </span>
                <span className="ml-1 text-sm text-gray-500">{`(${hotel.tripAdvisorRating}) reviews`}</span>
              </div>
              <Link
                to={`/resort/${hotel.slug}`}
                className="text-lg font-semibold hover:text-halo-pink"
              >
                {hotel.name}
              </Link>
            </div>
            {transferArrivalDescription && (
              <div className="flex justify-start mt-2">
                <div className="flex items-center bg-halo-pink-bg px-2 py-1 mb-2 rounded-md min-w-max">
                  <img src="/htag.svg" alt="Halo Complementary" className="w-4 h-4 mr-1" />
                  <span className="text-xs font-medium text-gray-800">Transfers Included</span>
                </div>
              </div>
            )}
            <div className={`flex justify-start ${transferArrivalDescription ? '-mt-2' : 'mt-2'}`}>
              <div className="flex items-center px-2 py-1 mb-2 rounded-md min-w-max">
                <img src="/featureIcons/cancellation.svg" alt="Halo Complementary" className="w-3 h-3 mr-1" />
                <span className="text-xs font-medium text-green-600 ml-1">Flexible Accommodation Cancellation</span>
              </div>
            </div>
            <div className="flex justify-start mt-1 md:hidden lg:hidden lgx2:hidden">
              <div className="flex items-center px-2 py-1 mb-2 rounded-md min-w-max">
                <img src="./featureIcons/deposit-secure.svg" alt="Deposit" className="w-3 h-3 mr-1" />
                <span className="text-xs font-medium text-gray-800">Deposit from <span className="font-normal px-1 text-halo-pink">{depositPrice === "***" ? depositPrice : `£ ${depositPrice.toFixed(0)} pp`}</span></span>
              </div>
            </div>
            {/* <div className="text-sm text-gray-800 line-clamp-2">
              {hotel.description}
            </div> */}
            <div>


              {/* {availablePropertyData && availablePropertyData.result.length > 0 && availablePropertyData?.result[0].groups[0].rooms[0].deals[0].cancellationPolicies.length > 0 ? (
                availablePropertyData?.result[0].groups[0].rooms[0].deals[0].cancellationPolicies.map((policy, policyIndex) => {

                  return (
                    <p key={policyIndex} className="text-[#198C1F] relative group text-sm">
                      {policy.description}
                    </p>
                  );
                })
              ) : (
                <span className="text-xs text-gray-500">Non refundable</span>
              )} */}

              {/* Bottom part with facilities */}
              <div className="mt-2">
                {propertyDetails?.facilities && propertyDetails.facilities.length > 0 && (
                  <>
                    <span className="text-sm font-semibold">Facilities</span>
                    <div className="hidden md:block lg:block lgx2:block">
                      <div className="flex flex-wrap gap-1 my-2 items-center">
                        {propertyDetails?.facilities.slice(0, 3).map((facility, index) => (
                          <span key={index} className="bg-[#e3eefa] text-xs font-semibold px-2 py-1 rounded text-gray-700">
                            {facility.name}
                          </span>
                        ))}
                        {propertyDetails.facilities.length > 3 && (
                          <Link to={`/resort/${hotel.slug}`} className="text-xs text-gray-500">
                            +{propertyDetails.facilities.length - 3} more
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-1 mt-2 items-center md:hidden lg:hidden lgx2:hidden">
                      {propertyDetails?.facilities.slice(0, 2).map((facility, index) => (
                        <span key={index} className="bg-[#e3eefa] text-xs font-semibold px-2 py-1 rounded text-gray-700">
                          {facility.name}
                        </span>
                      ))}
                      {propertyDetails.facilities.length > 2 && (
                        <Link to={`/resort/${hotel.slug}`} className="text-xs text-gray-500">
                          +{propertyDetails.facilities.length - 2} more
                        </Link>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>


        {/* Price and button container */}
        <div className="flex-none p-4 md:border-l md:w-1/4">

          <div className="hidden md:block lg:block lgx2:block">
            <span className="flex justify-center h-6 font-thin text-sm text-halo-pink pt-1 bg-halo-pink-bg whitespace-nowrap">
              <img src="../featureIcons/deposit-secure.svg"
                alt=""
                className="w-4 h-4 mr-2" />
              Deposit from
              <span className="font-normal px-1">{depositPrice === "***" ? depositPrice : `£ ${depositPrice.toFixed(0)} pp`}</span>
            </span>
          </div>
          <div className="flex justify-end md:justify-center md:items-center md:my-20 mb-4 md:w-full w-auto">
            <div className="flex justify-center md:w-full">
              <span className="text-lg font-bold ">
                <span className="text-lg font-bold">
                  {roomPriceNew > 0 && totalCount > 0 ? (
                    <>
                      <span className="text-sm text-gray-500 font-normal mr-2">From</span>
                      £ {(roomPriceNew / totalCount).toFixed(2)}pp
                    </>
                  ) : (
                    <span className="text-sm text-red-500 font-semibold">Not Available for selected dates</span>
                  )}
                </span>
              </span>
            </div>
          </div>
          <div className="flex md:justify-center justify-end md:mx-10 mt-2">
            <Link
              to={`/resort/${hotel.slug}`}
              // target="_blank"
              // rel="noopener noreferrer"
              className="bg-halo-pink text-white py-2 text-sm font-medium rounded hover:bg-pink-800 flex justify-center items-center md:w-full w-auto px-4"
            >
              View Deal
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchResultsCard;